
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("liSWT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $43227f7f6b3611d6$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $43227f7f6b3611d6$export$2e2bcd8739ae039 = {
    'extension.charts.aggregateData': "\uB370\uC774\uD130 \uC9D1\uACC4",
    'extension.charts.aggregateDataDescription': "\uC5EC\uB7EC \uD589\uC5D0 \uAC19\uC740 \uAC12\uC774 \uC788\uB294 \uACBD\uC6B0 \uAC12\uC744 \uB2E8\uC77C \uB370\uC774\uD130 \uD3EC\uC778\uD2B8\uB85C \uACB0\uD569\uD569\uB2C8\uB2E4.",
    'extension.charts.category': "\uBC94\uC8FC",
    'extension.charts.customizeTab': "\uC0AC\uC6A9\uC790 \uC9C0\uC815",
    'extension.charts.dataMissing.details': "\uD398\uC774\uC9C0\uC5D0\uC11C \uC774 \uCC28\uD2B8\uC758 \uC18C\uC2A4 \uD14C\uC774\uBE14\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'extension.charts.dataMissing.title': "\uD45C\uC2DC\uD560 \uB370\uC774\uD130\uAC00 \uC5C6\uC74C",
    'extension.charts.dataTab': "\uB370\uC774\uD130",
    'extension.charts.defaultColumnName': "{0} \uC5F4",
    'extension.charts.defaultTitle': "\uC81C\uBAA9 \uC5C6\uB294 \uCC28\uD2B8",
    'extension.charts.defaultYLabel': "\uC81C\uBAA9 \uC5C6\uB294 \uCD95",
    'extension.charts.extensionTitle': "\uCC28\uD2B8",
    'extension.charts.height': "\uADF8\uB9BC \uC601\uC5ED \uB192\uC774",
    'extension.charts.height.large': "\uB354 \uB192\uAC8C",
    'extension.charts.height.medium': "\uAE30\uBCF8\uAC12",
    'extension.charts.height.small': "\uB354 \uC9E7\uAC8C",
    'extension.charts.horizontal.orientation.label': "\uAC00\uB85C",
    'extension.charts.insert.tooltip': "\uCC28\uD2B8 \uC0BD\uC785",
    'extension.charts.legend': "\uBC94\uB840",
    'extension.charts.legend.auto': "\uC790\uB3D9",
    'extension.charts.legend.bottom': "\uD558\uB2E8",
    'extension.charts.legend.left': "\uC67C\uCABD",
    'extension.charts.legend.position': "\uBC94\uB840 \uC704\uCE58",
    'extension.charts.legend.right': "\uC624\uB978\uCABD",
    'extension.charts.legend.show': "\uBC94\uB840 \uD45C\uC2DC",
    'extension.charts.legend.top': "\uC0C1\uB2E8",
    'extension.charts.options.label': "\uCC28\uD2B8 \uC635\uC158",
    'extension.charts.options.tooltip': "\uCC28\uD2B8 \uC635\uC158 \uBCC0\uACBD",
    'extension.charts.orientation.label': "\uBC29\uD5A5",
    'extension.charts.seriesNames': "\uB370\uC774\uD130 \uC2DC\uB9AC\uC988",
    'extension.charts.showPoints': "\uB370\uC774\uD130 \uD3EC\uC778\uD2B8 \uD45C\uC2DC",
    'extension.charts.smoothLines': "\uBD80\uB4DC\uB7EC\uC6B4 \uC120",
    'extension.charts.style': "\uC2A4\uD0C0\uC77C",
    'extension.charts.title': "\uC81C\uBAA9",
    'extension.charts.type.bar': "\uB9C9\uB300",
    'extension.charts.type.fieldDescription': "\uCC28\uD2B8 \uC720\uD615",
    'extension.charts.type.line': "\uC120",
    'extension.charts.type.pie': "\uD30C\uC774",
    'extension.charts.userTitle': "\uC81C\uBAA9",
    'extension.charts.vertical.orientation.label': "\uC138\uB85C",
    'extension.charts.xAxis': "X\uCD95",
    'extension.charts.xLabel': "X\uCD95 \uB808\uC774\uBE14",
    'extension.charts.yLabel': "Y\uCD95 \uB808\uC774\uBE14"
};

});


//# sourceMappingURL=ko.8fea3671.js.map
